import React from "react";
import SingleEventPage from "../../components/single-event-page/SingleEventPage";
import IdeathonImg from "../../assets/event-images/ideathon.jpg";

const projectExpo = {
  image: IdeathonImg,
  description:
    "Join us for the Project Expo, where innovation meets creativity! Showcase your groundbreaking projects, impress the judges, and compete for exciting prizes. Let your ideas shine!",
  type: "Elite Event",
  eventName: "Project Expo",
  dateTime: "March 01, 10:00AM onwards",
  venue: "LBCH",
  rules: [
    "1-5 members per team",
    "Participants can showcase their innovative projects.",
    "Projects can be either software or hardware.",
    "Seperate prizes for hardware and software.",
    "Judging criteria: Innovation, Creativity, and Presentation.",
    
],
  firstprize: 2500,
  secondprize: 0,
  thirdprize: 0,
  contact: [

    {
      name: "Vasan",
      phoneNo: "9894188149",
    },
    {
      name: "Kawin",
      phoneNo: "8072177884",
    },
  ],
};



const ProjectExpo = () => {
  return (
    <SingleEventPage
      eventDetails={projectExpo}
      thirdprize={false}
      formsLink={"https://docs.google.com/forms/d/e/1FAIpQLSdIyMwYls62I-BA4iOeIeh9--2fU8CXTF6aHRztD2iMHTpG1w/viewform?usp=dialog"}
    />
  );
};

export default ProjectExpo;
